import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./SwiperCustom.css";
import images from "../../../assets/images";

interface SwiperOnboardingProps {
  onSlideChange?: (swiper: any) => void;
}

export const SwiperOnboarding = ({ onSlideChange }: SwiperOnboardingProps) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const footerImage = isMobile
    ? images.OnboardingChatFooterMB
    : images.OnboardingChatFooterDS;
  const headerImage = isMobile
    ? images.OnboardingChatHeaderMB
    : images.OnboardingChatHeaderDS;
  const testImage = isMobile
    ? images.OnboardingChatTestMB
    : images.OnboardingChatTestDS;

  const slidesPerView = isMobile ? 1.4 : 2;
  const imageSx = {
    display: "block",
    maxWidth: isMobile ? "280px" : "700px",
    width: isMobile ? "280px" : "100%",
    margin: "0 auto",
  };

  return (
    <Swiper
      slidesPerView={slidesPerView}
      centeredSlides
      loop
      slideToClickedSlide={true}
      modules={[Pagination, Autoplay]}
      autoplay={{ delay: 6000, disableOnInteraction: true }}
      allowTouchMove={true}
      onSlideChange={onSlideChange}
    >
      <SwiperSlide>
        <Box component="img" src={footerImage} alt="Footer" sx={imageSx} />
      </SwiperSlide>
      <SwiperSlide>
        <Box component="img" src={headerImage} alt="Header" sx={imageSx} />
      </SwiperSlide>
      <SwiperSlide>
        <Box component="img" src={testImage} alt="Test" sx={imageSx} />
      </SwiperSlide>
      <SwiperSlide>
        <Box component="img" src={footerImage} alt="Footer" sx={imageSx} />
      </SwiperSlide>
      <SwiperSlide>
        <Box component="img" src={headerImage} alt="Header" sx={imageSx} />
      </SwiperSlide>
      <SwiperSlide>
        <Box component="img" src={testImage} alt="Test" sx={imageSx} />
      </SwiperSlide>
    </Swiper>
  );
};
